import { render, staticRenderFns } from "./DelSupplierProductStok.vue?vue&type=template&id=a97cc32c&scoped=true&"
import script from "./DelSupplierProductStok.vue?vue&type=script&lang=js&"
export * from "./DelSupplierProductStok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97cc32c",
  null
  
)

export default component.exports